import './MenuBar.css'

const MenuBar = () => {
    return (
        <nav className="header">
            <div className="nav-wrapper">
                {/* <a className="logo" href='/'>Your Logo</a> */}
                {/* <input className="menu-btn" type="checkbox" id="menu-btn"/>
                <label className="menu-icon" htmlFor="menu-btn"><span className="navicon"></span></label> */}

                <ul className="landingMenu">
                    <li><a href="/">Home</a></li>
                    <li><a href="/app">App (beta)</a></li>                
                </ul>
            </div>
        </nav>
    )
}

export default MenuBar;
